import { filmFacts } from "@/mocks/lustCaution";

export default function Overview() {
  return (
    <section id="overview" className="w-full bg-background-50 scroll-mt-20">
      <div className="px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            <div className="lg:w-2/5">
              <p className="text-primary-600 font-label text-sm tracking-widest uppercase">Overview</p>
              <h2 className="mt-3 font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-snug">
                先认识这部电影
              </h2>
              <p className="mt-5 text-foreground-600 leading-relaxed">
                《色，戒》由李安执导，改编自张爱玲同名短篇，2007 年上映并摘得威尼斯电影节金狮奖。
                影片围绕一场未完成的刺杀展开，把人物放进真实与伪装、亲密与防备之间。
                也正因如此，不同版本的画面差异，才会牵动观众对剧情的理解。
              </p>
              <div className="mt-8 rounded-lg bg-secondary-100/70 border border-secondary-200 p-5">
                <p className="flex items-start gap-3 text-secondary-900 text-sm leading-relaxed">
                  <i className="ri-information-line text-lg mt-0.5" aria-hidden="true"></i>
                  本页内容面向成年观众，重点讨论版本差异与剧情结构。涉及亲密戏的部分，仅从叙事与人物关系角度解读，不展开具体画面描述。
                </p>
              </div>
            </div>

            <div className="lg:w-3/5">
              <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
                <div className="flex items-center gap-3 px-5 py-4 border-b border-background-200 bg-background-50">
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className="ri-clapperboard-line" aria-hidden="true"></i>
                  </span>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">影片档案</h3>
                </div>
                <dl className="divide-y divide-background-200">
                  {filmFacts.map((fact) => (
                    <div key={fact.label} className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-6 px-5 py-4">
                      <dt className="w-28 shrink-0 text-foreground-500 text-sm font-label">{fact.label}</dt>
                      <dd className="text-foreground-900 text-sm md:text-base leading-relaxed">{fact.value}</dd>
                    </div>
                  ))}
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}